let { View } = window.App;
let { t } = window.App.I18n;

View.addHook( 'init', v => {
    $country = v.$( '.js-country-dropdown' );
    $state = v.$( '.js-state-dropdown' );

    $country.on( 'change', function(){
        let url = $country.find( 'option:selected' ).data( 'ajax-url' );
        $state
            .prop( 'disabled', true )
            .html( `<option>${ t( 'loading' ) }...</option>` );

        $.ajax( {
            url,
            dataType: 'json',
            complete( response ){
                let options = $.map(
                    response.responseJSON,
                    ( state ) => `<option value="${ state.code }">${ state.name }</options>`,
                );

                $state
                    .prop( 'disabled', false )
                    .html( options.join( "\n" ) );
            },
        } );
    } );
} );



// WEBPACK FOOTER //
// ./resources/assets/js/modules/country-dropdown.js